import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountRequest from "./counterpartyBankAccountRequest";
import DecimalRangeRequest from "./decimalRangeRequest";
import RefundApprovalType from "./refundApprovalType";
import TransferPaymentType from "./transferPaymentType";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundsForRefundsOfRefundsRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  refundPaymentTemplateId?: string;

  @observable
  @Type(() => DecimalRangeRequest)
  refundAmount?: DecimalRangeRequest;

  @observable
  approvedBy?: RefundApprovalType;

  @observable
  notApprovedBy?: RefundApprovalType;

  @observable
  originalRefundOfficialRecordId?: string;

  @observable
  transferType!: TransferPaymentType;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  @Type(() => CounterpartyBankAccountRequest)
  senderBankAccount?: CounterpartyBankAccountRequest;

  @observable
  variableSymbol?: number;

  @observable
  paidAmount?: number;

  @observable
  @Type(() => Date)
  postingDate?: Date;
}

export const RefundsForRefundsOfRefundsRequestValidationRules: EntityValidationRules<RefundsForRefundsOfRefundsRequest> = {
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
  },
  refundAmount: {
    isNumberRange: {
      min: 0,
    },
  },
  originalRefundOfficialRecordId: {
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
};
